/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_GlobeiconInputs */

const en_enum_custom_page_icon_globeicon = /** @type {(inputs: Enum_Custom_Page_Icon_GlobeiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globe`)
};

const de_enum_custom_page_icon_globeicon = /** @type {(inputs: Enum_Custom_Page_Icon_GlobeiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globus`)
};

/**
* | output |
* | --- |
* | "Globe" |
*
* @param {Enum_Custom_Page_Icon_GlobeiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_globeicon = /** @type {((inputs?: Enum_Custom_Page_Icon_GlobeiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_GlobeiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_globeicon(inputs)
	return de_enum_custom_page_icon_globeicon(inputs)
});